import { useEffect } from "react";
import { Rectangle } from "recharts";

type Props = {
  props: any;
  loadCallback: (isLoaded: boolean) => void;
};

export const ActiveBar = ({ props, loadCallback }: Props) => {
  useEffect(() => {
    loadCallback(true);
    return () => {
      loadCallback(false);
    };
  }, [loadCallback]);

  return <Rectangle {...props} opacity={1} />;
};
